import { Component } from '@theme/component';

/**
 * DEARDOMINION footer accordion: toggles a Shopify-menu-driven link list
 * open/closed. The height animation itself is pure CSS (grid-template-rows
 * 0fr -> 1fr on the panel wrapper) -- this just flips aria-expanded and the
 * class that drives it. Enter/Space activation and visible keyboard focus
 * come for free from using a real <button> element.
 *
 * @typedef {Object} Refs
 * @property {HTMLButtonElement} trigger
 * @property {HTMLDivElement} panelWrapper
 *
 * @extends {Component<Refs>}
 */
class DDFooterAccordion extends Component {
  requiredRefs = ['trigger', 'panelWrapper'];

  toggle() {
    const isOpen = this.refs.trigger.getAttribute('aria-expanded') === 'true';
    this.refs.trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    this.refs.panelWrapper.classList.toggle('is-open', !isOpen);
  }
}

if (!customElements.get('dd-footer-accordion')) {
  customElements.define('dd-footer-accordion', DDFooterAccordion);
}
